
  class customCollapseToggle extends HTMLElement {
    constructor() {
        super(),
        this.toggle = this.querySelector(".collapse-toggle")
        this.btnText = this.toggle.querySelector(".btn__text")
    }
    connectedCallback() {
        if (!this.toggle) return;
        this.toggle.addEventListener("click", this.toggleClick.bind(this));
    }
    toggleClick() {
        console.log(this);
        
      let parent = this.querySelector(".rich-text__text");
      parent.classList.toggle("expanded");

      console.log(parent.classList.contains("expanded"));
      
      if (parent.classList.contains("expanded")) {
        this.btnText.textContent = this.toggle.dataset.less || "View less";
      } else {
        this.btnText.textContent = this.toggle.dataset.more || "View more";
      }
    }
}
customElements.define("custom-collapse-toggle", customCollapseToggle);

// banner video popUP
class CustomVideoPop extends HTMLElement {
    constructor() {
        super(),
        this.video = this.getAttribute("data-video")
        this.addEventListener("click",this.openPop.bind(this))
    }
    connectedCallback() {
    }
    openPop() {
          const modal = document.createElement('div');
          modal.className = 'video-modal-mask';
          modal.innerHTML = `
            <div class="custom-video-modal">
              <div class="custom-video-modal-content">
                <div class="video-modal-close" id="closeDynamicModal"><svg focusable="false" width="14" height="14" class="icon" viewBox="0 0 14 14"><path d="M13 13L1 1M13 1L1 13" stroke="currentColor" stroke-width="2" fill="#fff"></path></svg></div>
                <video src="${this.video}"playsinline controls autoplay muted loop style="width:100%; border-radius:12px;"></video>
              </div>
            </div>
          `;
          document.body.appendChild(modal);
          document.documentElement.classList.add("lock-all");
          const closeBtn = modal.querySelector('#closeDynamicModal');
          const videoEl = modal.querySelector("video");
          const closeModal = () => {
              videoEl.pause();
              modal.remove();
              document.documentElement.classList.remove("lock-all");
          };

          closeBtn.addEventListener("click", closeModal);

          // 点击遮罩关闭
          modal.addEventListener('click', (e) => {
              if (e.target === modal) {
                  closeModal();
              }
          });
        
    }
}
customElements.define("custom-video-pop", CustomVideoPop);

/* custom-compare-product */

class CompareProducts extends HTMLElement {
    constructor() {
        super();
        this.selects = this.querySelectorAll('select')
        console.log(this.selects);
        
        this.selects.forEach(select => {
            select.addEventListener("change",this.init.bind(this))
        });
        this.selectArr = []
        this.init()
    }
    get allObj(){
        let arr = this.querySelectorAll('[data-compare-product]')
        let allObj = []
        for (const item of arr) {
            let itemObj = JSON.parse(item.innerHTML)
            allObj.push(itemObj.data)
        }
        return allObj
    }
    init(){
        this.selectArr = Array.from(this.selects).map(select => select.value);
        this.renderHtml()
    }
renderHtml(){

    let result = []

    for (const index in this.allObj) {
        let current_item = this.allObj[index].filter(item => this.selectArr[index] == item.id)
        result.push(...current_item)
    }

    if (result.length === 0) return ""

    let html = ""
    const firstProductInfo = result[0].info

    for (let blockIndex = 0; blockIndex < firstProductInfo.length; blockIndex++) {

        const block = firstProductInfo[blockIndex]

        html += `
        <div class="compare-products-content">
            <div class="compare-products-content-title">${block.title}</div>
            <div class="compare-products-content-info">
        `

        for (let rowIndex = 0; rowIndex < block.list.length; rowIndex++) {

            const label = block.list[rowIndex].label

            html += `<div class="compare-products-row">
                        <span class="label">${label}</span>`

            for (const product of result) {
                const value = product.info[blockIndex].list[rowIndex].value || ""
                html += `<span class="value">${value}</span>`
            }

            html += `</div>`
        }

        html += `
            </div>
        </div>`
    }

    /* 🔥 新增下载按钮区域 */

    html += `<div class="compare-products-content compare-products-btns"><div class="compare-products-content-info"><div class="compare-products-row">
    <span class="label"></span>`

    result.forEach(product => {
        if(product.download_url){
            html += `
            <a class="value compare-download-btn"
               href="${product.download_url}"
               target="_blank">
               ${product.download_text || 'Download'}
            </a>
            `
        }
    })

    html += `</div></div></div>`

    this.querySelector(".compare-products-contents").innerHTML = html
}
}
window.customElements.define('compare-products', CompareProducts);


class CompareProduct extends HTMLElement {
    constructor() {
        super();
        this.select = this.querySelector('select')
        this.select.addEventListener("change", this.initSelect.bind(this));
        this.initSelect();
    }

    initSelect(){
        const selectedOption = this.select.selectedOptions[0]; 
        const dataPrice = selectedOption.getAttribute('data-price');
        const originalPrice = selectedOption.getAttribute('data-compare-price');
        const dataUrl = selectedOption.getAttribute('data-url');
        const dataImage = selectedOption.getAttribute('data-image');
        this.querySelectorAll(".compare-product-url").forEach(element => {
            element.setAttribute("href", dataUrl);
        });
        this.querySelector(".compare-product-image").querySelector("img").setAttribute("src", dataImage);
        const currentPriceEl = this.querySelector(".compare-current-price");
        const originalPriceEl = this.querySelector(".compare-original-price");

        currentPriceEl.innerHTML = dataPrice;

        if (originalPrice && originalPrice !== dataPrice) {
            originalPriceEl.innerHTML = originalPrice;
            originalPriceEl.style.display = "block";
        } else {
            originalPriceEl.style.display = "none";
        }
    }
}

window.customElements.define('compare-product', CompareProduct);

class customSelect extends HTMLElement {
    constructor() {
        super();
        this.isOpen = false;
        this.nativeSelect = this.querySelector("select")
        this.selectedEl = this.querySelector(".selected");
        this.optionsEl = this.querySelector(".options");
        this.optionItems = this.querySelectorAll(".option");
    }
    connectedCallback() {
        this.bindEvents();
    }
    bindEvents() {
        this.selectedEl.addEventListener("click", () => this.toggle());
        this.optionItems.forEach(option => {
            option.addEventListener("click", () => {
                this.chooseOption(option);
            });
        });
        document.addEventListener("click", (e) => {
            if (!this.contains(e.target)) {
                this.close();
            }
        });
        window.addEventListener("scroll", () => {
            this.close();
        });
    }
    toggle() {
        this.isOpen = !this.isOpen;
        this.classList.toggle("open", this.isOpen);
    }

    close() {
        if (this.isOpen) {
            this.isOpen = false;
            this.classList.remove("open");
        }
    }
      chooseOption(optionEl) {
        const value = optionEl.dataset.value;
        const label = optionEl.textContent.trim();
        this.selectedEl.textContent = label;
        this.nativeSelect.value = value;
        const event = new Event("change", { bubbles: true });
        this.nativeSelect.dispatchEvent(event);
        this.close();
    }
}

window.customElements.define('custom-select', customSelect);


// nav
  document.addEventListener('DOMContentLoaded', function() {
    const megamenuTitles = document.querySelectorAll('.custom_megamenu_title');

    megamenuTitles.forEach(title => {
      title.addEventListener('mouseenter', function() {
        const index = this.getAttribute('data-tab-index');
        const container = this.closest('.custom_megamenu_container');

        // 1. 切换左侧标题高亮
        container.querySelectorAll('.custom_megamenu_title').forEach(t => t.classList.remove('active'));
        this.classList.add('active');

        // 2. 切换右侧内容显示
        container.querySelectorAll('.custom_megamenu_content').forEach(content => {
          content.classList.remove('active');
          if (content.getAttribute('data-content-index') === index) {
            content.classList.add('active');
          }
        });
      });
    });
  });

  function showVideoWrapper(){
    document.querySelector(".galleryViewer-has-video-wrapper").querySelector("slider-component.slider-mobile-gutter").classList.add("hidden")
    document.querySelector(".galleryViewer-has-video-wrapper").querySelector(".galleryViewer-video-wrapper").classList.remove("hidden")
    document.querySelector(".galleryViewer-has-video-wrapper").querySelector(".galleryViewer-video-wrapper").querySelector("video").play()
    document.querySelector(".product-thumbnail-has-video-wrapper").classList.add("galleryViewer-video-active")
  }
   function showImageWrapper(){
    document.querySelector(".galleryViewer-has-video-wrapper").querySelector("slider-component.slider-mobile-gutter").classList.remove("hidden")
    document.querySelector(".galleryViewer-has-video-wrapper").querySelector(".galleryViewer-video-wrapper").classList.add("hidden")
    document.querySelector(".galleryViewer-has-video-wrapper").querySelector(".galleryViewer-video-wrapper").querySelector("video").pause()
    document.querySelector(".product-thumbnail-has-video-wrapper").classList.remove("galleryViewer-video-active")
  }